<app-settings-base
  title="{{'documentIntelligenceSettings.title' | translate}}"
  description="{{'documentIntelligenceSettings.text' | translate}}"
  details="{{'documentIntelligenceSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/document-intelligence">
</app-settings-base>
